<!--suppress JSNonASCIINames -->
<template>
  <vx-card>
    <div>
      <div class="flex justify-between items-center">
        <p style="font-size: 18px; font-weight: 700">하수처리시설 등록</p>
        <div class="flex justify-end">
          <vs-button class="ml-4" color="secondary" type="border" @click.stop.prevent="onClickDownloadExcel">엑셀(FMS) 내려받기</vs-button>
          <vs-button v-if="isEditable && !!fieldId" class="ml-4" color="secondary" type="border" @click="onClickDelete">
            삭제
          </vs-button>
          <vs-button class="ml-4" color="secondary" type="border" @click="onClickMoveList">목록</vs-button>
          <vs-button v-if="isEditable" class="ml-4" color="secondary" @click="onClickSave">저장</vs-button>
        </div>
      </div>

      <!-- 기본정보 -->
      <div class="mt-28px">
        <h5 class="mb-4"><i class="dot"></i> 기본정보</h5>
        <div class="writeGridContainer">
          <div>
            <div>관리주체</div>
            <ml-input readonly v-model="form.management_entity"/>
          </div>
          <div>
            <div>소유자</div>
            <ml-input readonly v-model="form.owner"/>
          </div>
          <div>
            <div>전화번호</div>
            <ml-input v-model="form.phoneNumber" :readonly="readonly"/>
          </div>
          <div>
            <div>보관자</div>
            <ml-input v-model="form.custodian" :readonly="readonly"/>
          </div>
          <div>
            <div>관리방법</div>
            <vs-select autocomplete v-model="form.관리방법">
              <vs-select-item text="직접관리" value="직접관리" />
              <vs-select-item text="위탁관리" value="위탁관리" />
            </vs-select>
          </div>
          <div>
            <div>소관부서</div>
            <ml-input v-model="form.소관부서" :readonly="readonly" />
          </div>
          <div>
            <div>담당주무관</div>
            <ml-input v-model="form.담당주무관" :readonly="readonly" />
          </div>
        </div>
      </div>
    </div>

    <!-- 시설물 정보 -->
    <sewage-treatment-write-body :form="form" :category-info="categoryInfo" :readonly="readonly" />

    <!-- 관리 부서 및 업체 등록 -->
    <company-add-module
      title="관리 부서 및 업체 등록"
      :tableColumns="[
        { head: '구분', key: 'com_type' },
        { head: '부서(업체)명', key: 'com_name' },
        { head: '연락처', key: 'phone' },
      ]"
      :isSimple="true"
      :readonly="readonly"
      v-model="companyList"
      @remove="removeCompany"
    />

    <!-- 전경사진 -->
    <photo-upload-grid-module :row-count="2" :grid-count="2" v-model="form.photoList" section-title="전경사진"
                              placeholder="전경사진" :readonly="readonly"/>

    <file-upload-module v-model="fileList" class="mt-28px" :readonly="readonly" target="field"/>
  </vx-card>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import CompanyAddModule from "@/views/_BS/components/CompanyAddModule";
import DateSelector from "@/components/selector/DateSelector";
import DateSelectorRang from "@/components/selector/DateSelectorRang";
import SignField from "@/components/SignField.vue";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import moment from "moment";
import BridgeWriteBody from "@/views/fields/single-page/bridge/BridgeWriteBody.vue";
import ExcelJS from "exceljs";
import SewageTreatmentWriteBody from "@/views/fields/single-page/sewage-treatment/SewageTreatmentWriteBody.vue";

export default {
  components: {
    SewageTreatmentWriteBody,
    BridgeWriteBody,
    FileUploadModule,
    CompanyAddModule,
    DateSelector,
    DateSelectorRang,
    SignField,
    PhotoUploadGridModule,
  },
  data() {
    return {
      form: {
        phoneNumber: "",
        custodian: "",
        관리방법: "직접관리",
        소관부서: "",
        담당주무관: "",

        facilityNumber: "",
        managementNumber: "",
        facilityName: "",
        routeDivision: "",
        routeDetail: "",

        facility_category_id: "",

        cat1: "",
        cat2: "",
        cat3: "",
        classification: "",

        socEvaluationTarget: "",
        address: "",
        management_entity: "",
        management_type: "",
        owner: "",
        ownerType: "",
        businessPlanApprovalDate: "",
        completionDate: "",
        defectLiabilityExpirationDate1: "",
        detailedSpecifications: "",
        safetyInspectionAndDiagnosisHistory: "",
        repairAndReinforcementHistory: "",
        accessibleVentCover: "",
        designPeriod: "",
        designer: "",
        defectLiabilityExpirationDate2: "",
        constructionPeriod: "",
        contractor: "",
        totalConstructionCost: "",
        seismicDesignTarget: "",
        seismicDesignApplication: "",
        seismicDesignStandard: "",
        seismicPerformanceEvaluation: "",
        seismicReinforcement: "",
        young21Target: "",
        auditPeriod: "",
        auditor: "",
        projectOwner: "",
        constructionName: "",
        defectLiabilityExpirationDate: "",
        constructionSupervisor: "",
        creationDate: moment().format("YYYY-MM-DD"),
        author: this.$store.state.auth.userInfo ? this.$store.state.auth.userInfo.name : "",
        signature: "",
        lastModifiedDate: "",
        lastModifiedBy: "",
        remarks: "",

        // 상세제원
        처리구역: "",
        일평균: "",
        일최대: "",
        시간최대: "",
        처리방식1차: "",
        처리방식2차: "",
        처리방식3차: "",
        유입수질_BOD: "",
        유입수질_COD: "",
        유입수질_SS: "",
        유입수질_TN: "",
        유입수질_TP: "",
        방류수질_BOD: "",
        방류수질_COD: "",
        방류수질_SS: "",
        방류수질_TN: "",
        방류수질_TP: "",
        하수관거시설_관종: "",
        하수관거시설_관경: "",
        하수관거시설_연장: "",
        하수관거시설_기타시설: "",
        수처리시설_침사지: "",
        수처리시설_유입펌프량: "",
        수처리시설_최초침전지: "",
        수처리시설_포기조: "",
        수처리시설_최종침전지: "",
        수처리시설_고도처리시설: "",
        수처리시설_기타시설: "",
        슬러지처리시설_농축조: "",
        슬러지처리시설_소화조: "",
        슬러지처리시설_탈수시설_탈수방법: "",
        슬러지처리시설_탈수시설_대수: "",
        슬러지처리시설_최종처분방법: "",
        슬러지처리시설_기타시설: "",
        기타상세제원: "",

        companyList: [],
        photoList: [],
      },

      companyList: [],
      userList: [],
      joinUsers: [],
      fileList: [],
      categoryInfo: {
        facility_category_id: 0,
        cat1: "",
        cat2: "",
        cat3: "",
        classification: "",
      },

      catLock: true,
    };
  },
  computed: {
    projectId() {
      return Number(this.$route.params.proj_id);
    },
    fieldId() {
      return this.$route.params.fieldId;
    },
    myInfo() {
      return this.$store.state.auth.userInfo;
    },
    isAdmin() {
      let isAdmin = false;
      const myInfo = this.$store.state.auth.userInfo;
      isAdmin = isAdmin || parseInt(myInfo.is_superuser) > 0;
      return isAdmin;
    },
    /**
     * 현재 사용자가 프로젝트 관리자인지 확인합니다.
     * 프로젝트 관리자는 사업장을 등록/수정/삭제할 수 있습니다.
     * @returns {boolean}
     */
    isProjectManager() {
      const memberInfo = this.$store.state.member.memberInfo;
      if (memberInfo) {
        if (memberInfo.is_superuser) {
          return true;
        }

        const projects = memberInfo.projects;
        if (projects && projects.length > 0) {
          for (const project of projects) {
            if (`${project.id}` === `${this.projectId}`) {
              return project.pivot.is_manager;
            }
          }
        }
      }
      return false;
    },
    /**
     * 사업장을 프로젝트 관리자만 수정할 수 있는지 확인합니다.
     * @returns {boolean}
     */
    isFieldEditByManagerOnly() {
      const projectInfo = this.$store.state.project.projectInfo;

      if (projectInfo.field_edit_by_manager_only) {
        return true;
      }

      return false;
    },
    isEditable() {
      if (this.isFieldEditByManagerOnly) {
        return this.isProjectManager;
      }
      return true;
    },
    readonly() {
      return !this.isEditable;
    },
  },
  watch: {
    async companyList() {
      await this.initMembers();
    },
  },
  async created() {
    await this.$store.dispatch("member/LOAD_MEMBER_DETAIL");
    await this.$store.dispatch("project/LOAD_PROJECT", {project_id: this.projectId});
  },
  async mounted() {
    if (this.fieldId) {
      await this.loadField();
    }
  },
  methods: {
    async loadField() {
      const fieldId = this.fieldId;
      await this.$store.dispatch("project/LOAD_FIELD", {fieldId});
      const info = this.$store.state.project.fieldInfo;

      this.joinUsers = info.users;
      this.form = {...this.form, ...info, ...JSON.parse(info.meta)};

      if (info.facility_category) {
        this.form.facility_category_id = info.facility_category.id;
        this.form.cat1 = info.facility_category.cat1;
        this.form.cat2 = info.facility_category.cat2;
        this.form.cat3 = info.facility_category.cat3;
        this.form.classification = info.facility_category.classification;

        this.categoryInfo = {
          facility_category_id: info.facility_category.id,
          cat1: info.facility_category.cat1,
          cat2: info.facility_category.cat2,
          cat3: info.facility_category.cat3,
          classification: info.facility_category.classification,
        };
      }

      if (this.form.companies && info.companies.length > 0) {
        const companies = [];
        for (const company of info.companies) {
          companies.push(company);
        }
        this.companyList = companies;

        await this.initMembers();
      }

      // 첨부파일
      this.form.fileList = info.attachments || [];
      if (this.form.fileList) {
        this.fileList = this.form.fileList;
      }

      // this.form.photoList 항목이 2개보다 적을 경우, 빈 항목을 추가한다.
      if (this.form.photoList.length < 2) {
        for (let i = this.form.photoList.length; i < 2; i++) {
          this.form.photoList.push({ id: "", url: "" });
        }
      }
    },

    async initMembers() {
      const joinUsers = this.joinUsers;
      const members = [];
      for (const company of this.companyList) {
        members.push(...(await this.loadMember(company.id)));
      }

      for (const member of members) {
        let join_project = false;
        for (const user of joinUsers) {
          if (user.id === member.id) {
            join_project = true;
            break;
          }
        }
        member.join_project = join_project;
      }

      this.userList = members;
    },

    async loadMember(company_id) {
      const page = 1;
      const perPage = 100;
      await this.$store.dispatch("company/LOAD_MEMBER_LIST", {page, perPage, company_id});
      return JSON.parse(JSON.stringify(this.$store.state.company.memberList));
    },

    removeCompany(company) {
      let i = 0;
      for (i = 0; i < this.joinUsers.length; i++) {
        const usr = this.joinUsers[i];
        if (usr.company_id === company.id) {
          this.joinUsers.splice(i, 1);
          i--;
        }
      }
    },

    customAlert(msg, title) {
      const customAlert = new CustomEvent("customAlert", {
        detail: {
          title: title ? title : "오류가 발생했습니다",
          message: msg,
        },
      });
      window.dispatchEvent(customAlert);
    },

    onClickSave() {
      // 필수 : facilityNumber, facilityName,
      if (!this.form.facilityNumber) {
        this.customAlert("시설물 번호를 입력해주세요.");
        return;
      }
      if (!this.form.facilityName) {
        this.customAlert("시설물명을 입력해주세요.");
        return;
      }

      const option = {
        project_id: this.projectId, // 프로젝트 ID
        field_name: this.form.facilityName, // 현장(시설물, 사업장) 이름
        contract_code: this.form.facilityNumber, // 계약번호
        address: this.form.address, // 주소
        phone: this.form.phoneNumber, // 대표번호
        be_completed_at: this.form.completionDate, // 준공일
        deposit_amount: this.form.totalConstructionCost, // 총공사비
        facility_category_id: this.form.facility_category_id, // Category
        uploads: this.fileList.map((file) => file.id), // 파일
      };

      const company_ids = [];
      for (const com of this.companyList) {
        company_ids.push(com.id);
      }
      option.company_ids = company_ids;

      if (this.fieldId) {
        const user_ids = [];
        if (this.joinUsers.length > 0) {
          for (const user of this.joinUsers) {
            user_ids.push(user.id);
          }
        }
        option.user_ids = user_ids;
      }

      // Meta
      option.meta = {...this.form, lastModifiedDate: moment().format("YYYY-MM-DD"), lastModifiedBy: this.myInfo.name};

      this.$emit('save', option)
    },
    onClickDelete() {
      if (!this.fieldId) return
      this.$emit('delete', this.fieldId)
    },
    onClickMoveList() {
      this.$emit('moveList')
    },
    async onClickDownloadExcel() {
      // 엑셀 파일 가져오기
      // 파일은 public/fms/ 경로에 저장되어 있다.
      const response = await fetch('/fms/시설물관리대장_충주하수처리장.xlsx');
      const arrayBuffer = await response.arrayBuffer();

      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(arrayBuffer);

      // 첫번째 시트의 이름 가져오기
      const worksheet = workbook.worksheets[0];

      // 시트에 데이터 입력하기
      await this.applyDataToSheet(workbook, worksheet);

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

      let fileName = '';
      if (this.form.facilityName) {
        if (this.form.facilityNumber) {
          fileName = `시설물관리대장_${this.form.facilityName}_${this.form.facilityNumber}`;
        } else {
          fileName = `시설물관리대장_${this.form.facilityName}`;
        }
      } else if (this.form.facilityNumber) {
        fileName = `시설물관리대장_${this.form.facilityNumber}`;
      } else {
        fileName = `시설물관리대장`;
      }
      fileName += '.xlsx';

      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    },
    async applyDataToSheet(workbook, worksheet) {
      const cellMatchInfo = {
        facilityNumber: ['V4', 'B20'],  // 시설물번호
        managementNumber: ['V5', 'K20'], // 관리번호
        facilityName: ['V6', 'P20', 'B42'], // 시설물명
        management_entity: ['U13', 'S22'], // 관리주체
        owner: ['U14'], // 소유자
        custodian: ['U15'], // 보관자
        routeDivision: ['X20'], // 하천명-구분
        routeDetail: ['AC20'], // 하천명-세부노선
        cat3: ['AG20'], // 시설물종류
        classification: ['AL20'],  // 시설물종별
        cat1: ['AP20'], // 시설물구분
        socEvaluationTarget: ['AV20'], // SOC성능평가대상
        address: ['B22'], // 주소
        businessPlanApprovalDate: ['B27'], // 사업계획승인일
        completionDate: ['G27'], // 준공일
        defectLiabilityExpirationDate1: ['O27'], // 하자보수보증종료일
        detailedSpecifications: ['T27'], // 상세제원
        safetyInspectionAndDiagnosisHistory: ['W27'], // 안전점검진단이력
        repairAndReinforcementHistory: ['AD27'], // 보수보강이력
        accessibleVentCover: ['AI27'], // 통풍구방법
        designer: ['Q29'], // 설계자
        contractor: ['AH29'], // 시공자
        totalConstructionCost: ['AS29'], // 총공사비
        seismicDesignTarget: ['E31'], // 지진설계대상
        seismicDesignApplication: ['Q31'], // 지진설계적용
        seismicDesignStandard: ['Y31'], // 지진설계기준
        seismicPerformanceEvaluation: ['AH31'], // 지진성능평가
        seismicReinforcement: ['AS31'], // 지진보강
        young21Target: ['B33'], // 영21조대상
        auditor: ['Q33'], // 감리자
        projectOwner: ['Y33'], // 사업주체
        constructionName: ['AH33'], // 공사명
        constructionSupervisor: ['AS33'], // 공사감독
        creationDate: ['B36'], // 작성일
        lastModifiedDate: ['Z36'], // 최종 수정일
        lastModifiedBy: ['AM36'], // 최종 수정자
        remarks: ['D37'], // 비고

        // 상세제원
        처리구역: ['L42'],
        처리방식1차: ['F44'],
        처리방식2차: ['V44'],
        처리방식3차: ['AK44'],
        하수관거시설_관종: ['F49'],
        하수관거시설_관경: ['V49'],
        하수관거시설_연장: ['AG49'],
        하수관거시설_기타시설: ['AQ49'],
        수처리시설_침사지: ['F51'],
        수처리시설_유입펌프량: ['V51'],
        수처리시설_최초침전지: ['AG51'],
        수처리시설_포기조: ['AQ51'],
        수처리시설_최종침전지: ['F53'],
        수처리시설_고도처리시설: ['V53'],
        수처리시설_기타시설: ['AG53'],
        슬러지처리시설_농축조: ['F56'],
        슬러지처리시설_소화조: ['R56'],
        슬러지처리시설_탈수시설_탈수방법: ['AB56'],
        슬러지처리시설_탈수시설_대수: ['AK56'],
        슬러지처리시설_최종처분방법: ['AQ56'],
        슬러지처리시설_기타시설: ['AW56'],
        기타상세제원: ['L57'],
      };


      for (const key in cellMatchInfo) {
        const cell = cellMatchInfo[key];
        for (const c of cell) {
          worksheet.getCell(c).value = this.form[key] ? this.form[key] : '';
        }
      }


      worksheet.getCell('Z25').value = '';
      worksheet.getCell('AD25').value = '';
      worksheet.getCell('AH25').value = '';
      worksheet.getCell('AL23').value = '';
      if (this.form.management_type === '중앙부처') {
        worksheet.getCell('W25').value = 'V';
      } else if (this.form.management_type === '지자체') {
        worksheet.getCell('AA25').value = 'V';
      } else if (this.form.management_type === '(국가/지방)공기업') {
        worksheet.getCell('AE25').value = 'V';
      } else if (this.form.management_type === '민간') {
        worksheet.getCell('AG23').value = 'V';
      }

      worksheet.getCell('AU25').value = '';
      worksheet.getCell('BB25').value = '';
      worksheet.getCell('BD25').value = '';
      worksheet.getCell('BG23').value = '';
      if (this.form.ownerType === '중앙부처') {
        worksheet.getCell('AN25').value = 'V';
      } else if (this.form.ownerType === '지자체') {
        worksheet.getCell('AT25').value = 'V';
      } else if (this.form.ownerType === '(국가/지방)공기업') {
        worksheet.getCell('AU25').value = 'V';
      } else if (this.form.ownerType === '민간') {
        worksheet.getCell('AX23').value = 'V';
      }

      // 전화번호 (AK14)
      worksheet.getCell('AK14').value = `전화번호: ${this.form.phoneNumber}`;

      // 첨부자료 목록 (AV27)
      const fileNames = this.fileList.map((file) => file.originalName).join(', ');
      worksheet.getCell('AV27').value = fileNames;

      // 설계기간 (B29)
      worksheet.getCell('B29').value = `${this.form.designPeriod.sDate  } ~ ${  this.form.designPeriod.eDate}`;

      // 공시기간 (Y29)
      worksheet.getCell('Y29').value = `${this.form.constructionPeriod.sDate  } ~ ${  this.form.constructionPeriod.eDate}`;

      // 감리기간 (E33)
      worksheet.getCell('E33').value = `${this.form.auditPeriod.sDate  } ~ ${  this.form.auditPeriod.eDate}`;

      // 작성자 (M36)
      worksheet.getCell('M36').value = `${this.form.author }  (인)`;

      // 상세제원 - 일평균
      worksheet.getCell('V42').value = `${this.form.일평균 } ㎥/일`;

      // 상세제원 - 일최대
      worksheet.getCell('AG42').value = `${this.form.일최대 } ㎥/일`;

      // 상세제원 - 시간최대
      worksheet.getCell('AQ42').value = `${this.form.시간최대 } ㎥/h`;

      // 상세제원 - 유입수질
      worksheet.getCell('B47').value = `${this.form.유입수질_BOD } mg/l`;
      worksheet.getCell('F47').value = `${this.form.유입수질_COD } mg/l`;
      worksheet.getCell('L47').value = `${this.form.유입수질_SS } mg/l`;
      worksheet.getCell('R47').value = `${this.form.유입수질_TN } mg/l`;
      worksheet.getCell('V47').value = `${this.form.유입수질_TP } mg/l`;
      worksheet.getCell('AB47').value = `${this.form.방류수질_BOD } mg/l`;
      worksheet.getCell('AG47').value = `${this.form.방류수질_COD } mg/l`;
      worksheet.getCell('AK47').value = `${this.form.방류수질_SS } mg/l`;
      worksheet.getCell('AQ47').value = `${this.form.방류수질_TN } mg/l`;
      worksheet.getCell('AW47').value = `${this.form.방류수질_TP } mg/l`;
      async function blobToString (blob) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onerror = reject;
          reader.onload = () => { resolve(reader.result) };
          reader.readAsDataURL(blob);
        })
      }

      for (const photo of this.form.photoList) {
        if (photo.id) {
          const paths = photo.path.split("/");
          const hashedName = paths[paths.length - 1];
          const ext = hashedName.split(".")[1];

          await this.$store.dispatch("file/FILE_DOWNLOAD", { hashedName }).then(async (response) => {
            const imageId = await workbook.addImage({
              base64: await blobToString(response),
              extension: ext,
            });
            worksheet.addImage(imageId, {
              tl: {col: 1.2, row: 59.01 + imageId},
              ext: {width: 500, height: 400},
            })
            if (imageId > 0) {
              worksheet.getRow(60 + imageId).height = 320;
              worksheet.unMergeCells(`B${60 + imageId}:AA${60 + imageId}`)
              worksheet.mergeCells(`B${60 + imageId}:AA${60 + imageId}`)
              worksheet.unMergeCells(`AB${60 + imageId}:AX${60 + imageId}`)
              worksheet.mergeCells(`AB${60 + imageId}:AX${60 + imageId}`)
            }
          });
        }
      }

    }
  },
};
</script>

<style scoped lang="scss">
table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  th,
  td {
    font-size: 14px;
    font-weight: 500;
    text-align: center;

    border: 1px solid #cdcdcd;
    padding: 5px;
  }

  th {
    background: #f9f9f9;
    padding: 10px 4px;
  }
}
</style>
<style scoped lang="scss">
.table-list {
  .action-button {
    margin-left: auto;
  }
}

.title {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
  position: relative;
  padding-left: 12px;

  &::before {
    content: "";
    width: 8px;
    height: 8px;
    background: #7e72f2;
    display: block;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: -8px;
    border-radius: 100%;
  }
}

.title-n {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
}

.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}

.size-search {
  width: 200px;
}

.input-se {
  width: 100%;

  &::v-deep .start-end-title {
    width: 114px;
    font-weight: 500;
    font-size: 14px;
    justify-content: flex-start;
  }

  &::v-deep .mr-2 {
    flex: 1;
    margin-right: 10px !important;
  }

  &::v-deep .mr-2 + .mr-2 {
    margin-right: 0 !important;

    &::before {
      content: "~";
      margin-right: 10px;
    }
  }

  &::v-deep .inline-block {
    width: 100% !important;
  }
}

.vs-table-primary .is-selected {
  background: rgba(126, 114, 242, 0.6) !important;
  color: white;
}

.search-item {
  width: 100% !important;
  margin: 0 !important;

  &::v-deep > div:first-child {
    width: 114px !important;
    font-weight: 500;
    font-size: 14px;
  }

  &::v-deep > div:last-child {
    flex: 1 !important;

    .con-select {
      width: 100%;
    }
  }
}

.upload-img {
  width: 100%;
  height: 318px !important;
  margin-top: 22px;
}
</style>

<style lang="scss">
.none-card {
  box-shadow: none;
  border-radius: 0;
  display: inline-block;

  .vx-card__body {
    padding: 0 !important;
  }
}

span.up {
  color: #28c76f;
}

span.down {
  color: #ea5455;
}

.vs-table--tbody-table tr:nth-child(2n) {
  background-color: #f9f9f9;
}
</style>
